var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0   0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 25) rotate(-10)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 90,
    rx: 12,
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 52,
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: "bold",
    fill: "white",
    dominantBaseline: "middle",
    textAnchor: "middle"
  }, "\n      30%\n      ", /*#__PURE__*/React.createElement("tspan", {
    dx: 4,
    fontSize: 20
  }, "\u20AC")), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 14,
    r: 5,
    fill: "#6A9EEB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 115) rotate(5)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 90,
    rx: 12,
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 52,
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: "bold",
    fill: "white",
    dominantBaseline: "middle",
    textAnchor: "middle"
  }, "\n      50%\n      ", /*#__PURE__*/React.createElement("tspan", {
    dx: 4,
    fontSize: 20
  }, "\u20AC")), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 14,
    r: 5,
    fill: "#EB6A60"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(185, 65)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 14,
    fill: "#3C4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.5,-4 C-4.5,-6.5 -3,-8 0,-8 C3,-8 4.5,-6.5 4.5,-4 L4.5,2 C4.5,2.75 3.75,3.5 3,3.5 L-3,3.5 C-3.75,3.5 -4.5,2.75 -4.5,2 Z M3,2 L3,-4 C3,-5.5 2,-6.5 0,-6.5 C-2,-6.5 -3,-5.5 -3,-4 L-3,2 L3,2 Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default __webpack_public_path__ + "static/media/promo.64dd3bd443afbb5694b1e9c8af92cc49.svg";
export { ForwardRef as ReactComponent };